import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import styles from './Guide.module.css';

const MethodInfoModal = ({ method, onClose }) => {
  if (!method) return null;

  return (
    <div className={styles['modal-overlay']}>
      <AnimatePresence>
        <motion.div
          key={method.id}
          className={styles['modal-content']}
          initial={{ scale: 0.95, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.9, opacity: 0 }}
          transition={{ duration: 0.3, ease: 'easeOut' }}
        >
          <button className={styles['modal-close']} onClick={onClose}>✖</button>

          <div style={{ marginBottom: '1rem' }}>
            <h2 style={{ fontSize: '1.6rem' }}>{method.icon} {method.title}</h2>
            <p style={{ fontSize: '1rem', marginTop: '0.5rem' }}>
              <strong>🎯 Objectif :</strong><br /> {method.shortDesc}
            </p>
            {method.description && (
              <p style={{ fontSize: '0.95rem', color: '#444', marginTop: '0.5rem' }}>
                {method.description}
              </p>
            )}
          </div>

          <div style={{ marginBottom: '1.2rem' }}>
            <h3 style={{ fontSize: '1.2rem', marginBottom: '0.3rem' }}>📘 Utilisation recommandée</h3>
            <p>{method.usage}</p>
          </div>

          <div style={{ marginBottom: '1.2rem' }}>
            <h3 style={{ fontSize: '1.2rem', marginBottom: '0.3rem' }}>✅ Avantages</h3>
            <ul>
              {method.advantages.map((adv, i) => (
                <li key={i}>• {adv}</li>
              ))}
            </ul>
          </div>

          <div style={{ marginBottom: '1.2rem' }}>
            <h3 style={{ fontSize: '1.2rem', marginBottom: '0.3rem' }}>⚠️ Inconvénients</h3>
            <ul>
              {method.disadvantages.map((dis, i) => (
                <li key={i}>• {dis}</li>
              ))}
            </ul>
          </div>

          <div style={{ fontSize: '0.9rem', color: '#666', marginTop: '1rem' }}>
            📎 Niveaux disponibles : {method.levels.join(' | ')}
          </div>
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default MethodInfoModal;
